import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-clickable-link',
  imports: [CommonModule],
  template: `
    <span 
      class="clickable-link"
      [ngClass]="customClass"
      (click)="handleClick()">
      {{ linkText }}
    </span>
  `,
  styles: [`
    .clickable-link {
      font-family: Arial;
      font-weight: 600;
      font-style: SemiBold;
      font-size: 16px;
      line-height: 150%;
      letter-spacing: 0%;
      vertical-align: middle;
      color: #2367B9;
      cursor: pointer;
      text-decoration: none;
    }

    .clickable-link:hover {
      text-decoration: none;
    }

    /* Modifier for white, underlined link (e.g., on banners) */
    .clickable-link.white-underline {
      color: #ffffff;
      text-decoration: underline;
    }

    .clickable-link.white-underline:hover {
      text-decoration: underline;
    }

    /* Responsive */
    @media (max-width: 768px) {
      .clickable-link {
        font-size: 14px;
      }
    }
  `]
})
export class ClickableLink {
  @Input() linkText: string = '';
  @Input() linkType: 'phone' | 'portal' | 'custom' = 'phone';
  @Input() phoneNumber: string = '919-391-7202';
  @Input() portalUrl: string = 'https://patient-portal.animosanopsychiatry.com';
  @Input() customEventName: string = '';
  @Input() customClass?: string;
  @Output() clicked = new EventEmitter<void>();

  private pushDataLayerEvent(eventName: string, payload: Record<string, unknown> = {}) {
    const normalizedEventName = String(eventName || '').trim();
    if (!normalizedEventName) return;
    try {
      const dataLayer = (window as any).dataLayer = (window as any).dataLayer || [];
      dataLayer.push({
        event: normalizedEventName,
        ...payload
      });
    } catch {}
  }

  private trackPhoneClick(phoneNumber: string) {
    this.pushDataLayerEvent('phone_call_click', {
      phone_number: String(phoneNumber || ''),
      click_source: 'clickable_link'
    });
  }

  handleClick() {
    if (this.linkType === 'phone') {
      this.trackPhoneClick(this.phoneNumber);
      window.open(`tel:${this.phoneNumber}`, '_self');
    } else if (this.linkType === 'portal') {
   
      window.open(this.portalUrl, '_blank');
    } else if (this.linkType === 'custom') {
      this.pushDataLayerEvent(this.customEventName, {
        click_source: 'clickable_link',
        link_text: String(this.linkText || '')
      });
      this.clicked.emit();
    }
  }
}
